<template>
    <div class="calendar-month">
        <div class="calendar-month-header">{{ headerLabel }}</div>
        <div class="calendar-weeks">
            <span class="week-day" v-for="(week, idx) in weeks" :key="idx">{{ week }}</span>
        </div>
        <div class="calendar-month-days" @click="dayClickHandler">
            <span
                v-for="(date, idx) in monthDates"
                :key="idx"
                :attr-idx="idx"
                class="calendar-day"
                :class="{ 'day-active': date.canClick, 'day-disabe': !date.canClick, 'day-selected': date.isSelected }"
            >
                {{ date.value }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "CalendarMonth",
    props: ["monthDate", "disableRanges", "selectedRange"],
    computed: {
        headerLabel() {
            return this.zhiji.dateFormat(this.monthDate, "YYYY" + this.$t("zhiji.calendar.year") + "MM" + this.$t("zhiji.calendar.month"));
        },
        monthDates() {
            return this.getMonthWithDate(this.monthDate);
        },
        weeks() {
            return [
                this.$t("zhiji.calendar.sunday"),
                this.$t("zhiji.calendar.monday"),
                this.$t("zhiji.calendar.tuesday"),
                this.$t("zhiji.calendar.wednesday"),
                this.$t("zhiji.calendar.thursday"),
                this.$t("zhiji.calendar.friday"),
                this.$t("zhiji.calendar.saturday")
            ];
        }
    },
    methods: {
        dayClickHandler(event) {
            const index = event.target.getAttribute("attr-idx");

            if (!index) {
                return;
            }

            const selectDay = this.monthDates[index];

            if (selectDay.canClick) {
                let selectDate = new Date(this.monthDate.getTime());
                selectDate.setDate(selectDay.value);
                this.$emit("dateClick", selectDate);
            }
        },
        getMonthWithDate(date) {
            const monthStart = getMonthFirstDate(date);
            const monthEnd = getMonthLastDate(date);
            const lastMonthEnd = getMonthLastDate(new Date(monthStart.getTime() - getDayMilliseconds()));

            let days = [];

            // 当月的日期
            let monthDate = new Date(monthStart.getTime());
            while (this.isDateInRange(monthDate, monthStart, monthEnd)) {
                let canClick = !this.isInDisableRange(monthDate);
                let isSelected = canClick && this.isInSelectedRange(monthDate);
                days.push(this.getDayObj(monthDate, canClick, isSelected));

                monthDate.setDate(monthDate.getDate() + 1);
            }

            // 上个月不可点击日期补充
            monthDate = new Date(lastMonthEnd.getTime());
            while (monthDate.getDay() < 6) {
                days.unshift(this.getDayObj(monthDate, false, false));
                monthDate.setDate(monthDate.getDate() - 1);
            }

            // 下个月不可点击日期补充
            monthDate = new Date(monthEnd.getTime() + getDayMilliseconds());
            while (monthDate.getDay() > 0) {
                days.push(this.getDayObj(monthDate, false, false));
                monthDate.setDate(monthDate.getDate() + 1);
            }

            return days;
        },
        getDayObj(date, canClick, isSelected) {
            return {
                value: date.getDate(),
                isSelected: isSelected,
                canClick: canClick
            };
        },
        isInDisableRange(date) {
            if (this.disableRanges) {
                return this.disableRanges.some(range => {
                    return this.isInRange(date, range);
                });
            }

            return false;
        },
        isInSelectedRange(date) {
            return this.isInRange(date, this.selectedRange);
        },
        isInRange(date, range) {
            if (!range) {
                return false;
            } else if (!range.start && !range.end) {
                return false;
            }

            if (range.start && this.zhiji.dateFormat(date, "YYYYMMDD") < this.zhiji.dateFormat(range.start, "YYYYMMDD")) {
                return false;
            }

            if (range.end && this.zhiji.dateFormat(date, "YYYYMMDD") > this.zhiji.dateFormat(range.end, "YYYYMMDD")) {
                return false;
            }

            return true; // 在区间里面[start, end], [-, end], [start, -]
        },
        isDateInRange(date, start, end) {
            return (
                this.zhiji.dateFormat(date, "YYYYMMDD") >= this.zhiji.dateFormat(start, "YYYYMMDD") &&
                this.zhiji.dateFormat(date, "YYYYMMDD") <= this.zhiji.dateFormat(end, "YYYYMMDD")
            );
        }
    }
};
// 获取月份的第一天
function getMonthFirstDate(date) {
    let monthStart = new Date(date.getTime());
    monthStart.setDate(1);

    return monthStart;
}

// 获取月份的第最后天
function getMonthLastDate(date) {
    let monthEnd = new Date(date.getTime());
    monthEnd.setDate(1);
    monthEnd.setMonth(1 + monthEnd.getMonth());
    monthEnd.setTime(monthEnd.getTime() - getDayMilliseconds());

    return monthEnd;
}

// 一天的秒数
function getDayMilliseconds() {
    return 24 * 60 * 60 * 1000;
}
</script>

<style lang="scss" scoped>
.calendar-month {
    width: 300px;
    font-size: 14px;
    border-radius: 4px;
    padding: 0 20px 0 20px;
    box-sizing: border-box;

    .calendar-month-header {
        height: 56px;
        line-height: 56px;
        text-align: center;
    }

    .calendar-weeks {
        font-weight: 600;
        background: #f2f7fb;
        font-size: 0;
        text-align: center;

        .week-day {
            display: inline-block;
            text-align: center;
            width: 33px;
            height: 33px;
            line-height: 33px;
            font-size: 12px;
        }
    }

    .calendar-month-days {
        padding: 5px 0 12px;
        max-width: 232px;
        margin: 0 auto;
    }

    .calendar-day {
        display: inline-block;
        width: 33px;
        height: 33px;
        line-height: 33px;
        text-align: center;
        font-size: 12px;
        cursor: pointer;
    }

    .day-disabe {
        color: #9b9ba3;
        cursor: default;
    }

    .day-selected {
        background: #2ec2ff;
        color: #fff;
    }

    .day-active {
        &:hover {
            background: #2ec2ff;
            color: #fff;
        }
    }
}
</style>
